import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Hummingbird } from "../components/Hummingbird";

const LOGIN_HERO = "https://static.prod-images.emergentagent.com/jobs/58cc80bf-3ce9-447a-8ea0-2c27f6c8bb91/images/ba230f60ba5bd2d5eb213e632325fc57d17dcf8976bc74ab8d00af6f61a5424f.png";

export default function Login() {
    const location = useLocation();
    const errorMsg = location.state?.error;

    const handleGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen w-full bg-[#F9F8F3] relative overflow-hidden" data-testid="login-page">
            {/* Decorative shapes */}
            <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#0F5C60]/5 blur-3xl" />
            <div className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full bg-[#C0324F]/5 blur-3xl" />

            <div className="relative max-w-6xl mx-auto px-6 lg:px-10 pt-8 lg:pt-12">
                <div className="flex items-center gap-2">
                    <Hummingbird size={32} />
                    <span className="font-display text-xl font-semibold text-[#1E2623]">Flight Plan</span>
                </div>
            </div>

            <div className="relative max-w-6xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-center pt-10 lg:pt-20 pb-20">
                <div className="fade-up">
                    <p className="text-xs uppercase tracking-[0.25em] text-[#0F5C60] font-medium mb-5">
                        A checklist that takes flight
                    </p>
                    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-[#1E2623]">
                        Shawna&apos;s
                        <span className="block text-[#0F5C60]">Flight Plan.</span>
                    </h1>
                    <p className="mt-6 text-base sm:text-lg text-[#57675F] max-w-md leading-relaxed">
                        A shared, prioritized checklist of every step Shawna needs to reach her goals — with progress notes,
                        completion check-ins, and a gentle hummingbird cheering her on.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-3">
                        <Button
                            data-testid="login-google-button"
                            onClick={handleGoogle}
                            className="bg-[#0F5C60] hover:bg-[#0A464A] text-white rounded-full px-7 py-6 text-base font-medium shadow-[0_8px_24px_-8px_rgba(15,92,96,0.45)]"
                        >
                            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" aria-hidden="true">
                                <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.6 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
                                <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/>
                                <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.1 35.1 26.7 36 24 36c-5.3 0-9.7-3.4-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
                                <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.7l6.2 5.2C41.9 35.7 44 30.3 44 24c0-1.2-.1-2.4-.4-3.5z"/>
                            </svg>
                            Continue with Google
                        </Button>
                    </div>

                    {errorMsg && (
                        <div
                            className="mt-5 text-sm text-[#C0324F] bg-[#C0324F]/8 border border-[#C0324F]/20 rounded-2xl px-4 py-3 max-w-md"
                            data-testid="login-error"
                        >
                            {errorMsg}
                        </div>
                    )}

                    <div className="mt-8 text-xs text-[#57675F]/80 leading-relaxed" data-testid="invite-list">
                        <span className="font-medium text-[#1E2623]">Invited guests:</span>
                        {" "}c130usmc@gmail.com (admin) · shawnajordan11@gmail.com · jordanshawna44@gmail.com · iq.ai.solutions@gmail.com
                    </div>
                </div>

                <div className="relative hidden lg:flex items-center justify-center">
                    <div className="absolute inset-10 rounded-[3rem] bg-gradient-to-br from-[#0F5C60]/10 via-transparent to-[#C0324F]/10" />
                    <img
                        src={LOGIN_HERO}
                        alt="Hummingbird illustration"
                        className="relative hummingbird-float w-full max-w-md drop-shadow-[0_20px_40px_rgba(15,92,96,0.15)]"
                    />
                </div>
            </div>

            <footer className="relative max-w-6xl mx-auto px-6 lg:px-10 py-8 text-xs text-[#57675F]/70">
                Made with care · Every small step is a wingbeat.
            </footer>
        </div>
    );
}
